import { HOST, } from "common/constants";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import classes from "./ourProjects.module.scss";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import parse from "html-react-parser";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const OurProjects = () => {
  const [expandedProjects, setExpandedProjects] = useState({});
  const mediaDeskTop = useMediaQuery("(max-width: 1050px)");
  const isMobile = useMediaQuery("(max-width: 575px)");
  const numSlice = isMobile ? -1 : mediaDeskTop ? 130 : 255;
  const { t } = useTranslation();

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const { i18n } = useTranslation();
  const currentLang = i18n.language;


  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(`${HOST}/api/v1/ourprojects/`);
        setProjects(res.data.results || []);
      } catch (err) {
        console.error("Ошибка при получении данных о проектах:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    Fancybox.bind('[data-fancybox="gallery"]', {});
    return () => Fancybox.destroy();
  }, []);

  const toggleProject = (projectId) => {
    setExpandedProjects((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };

  // Функция для удаления HTML тегов из текста
  const stripHtml = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>/g, "");
  };

  if (loading) {
    return <Typography></Typography>;
  }


  return (
    <Box>
      {projects.map((project, index) => {
        // Используем id проекта или индекс как fallback
        const projectId = project.id || `project-${index}`;
        const descriptionKey = `description_${currentLang}`;
        const shortDescription = project?.short_description || "";
        const fullDescription = project?.[descriptionKey] || shortDescription;

        const isExpanded = expandedProjects[projectId] || false;

        const parsedDescription = parse(fullDescription, {
          replace: (domNode) => {
            if (
              domNode.name === "img" &&
              domNode.attribs?.src &&
              domNode.attribs.src.startsWith("/")
            ) {
              domNode.attribs.src = HOST + domNode.attribs.src;
              delete domNode.attribs.style;

              return (
                <a data-fancybox="gallery" href={domNode.attribs.src}>
                  <img
                    src={domNode.attribs.src}
                    alt="img"
                    style={{
                      maxWidth: "100%",
                      width: "100%",
                      height: "auto",
                      display: "block",
                      position: "static",
                    }}
                  />
                </a>
              );
            }

            if (domNode.name === "a" && domNode.attribs?.href) {
              if (domNode.attribs.href.startsWith("/")) {
                domNode.attribs.href = HOST + domNode.attribs.href;
              }

              if (
                domNode.attribs.href.startsWith("http") ||
                domNode.attribs.href.startsWith("https")
              ) {
                domNode.attribs.target = "_blank";
                domNode.attribs.rel = "noopener noreferrer";
              }
            }

            return undefined;
          },
        });

        // Для свернутого состояния используем чистый текст без HTML тегов
        const plainTextDescription = stripHtml(shortDescription);

        return (
          <Box key={projectId} marginBottom="40px">
            <Box className={classes.projectCard}>
              <a data-fancybox="gallery" href={project.image}>
                <Box
                  component="img"
                  className={classes.projectImg}
                  src={project.image}
                  alt={project.title}
                />
              </a>
              <Box className={classes.column}>
                <Typography className={classes.projectTitle}>
                  {project.title?.slice(0, 87)}
                </Typography>
                <Typography className={classes.description}>
                  {isExpanded
                    ? parsedDescription
                    : plainTextDescription.slice(0, numSlice) + "..."}
                </Typography>
                <Button
                  className={classes.readBtn}
                  variant="contained"
                  onClick={() => toggleProject(projectId)}
                >
                  {isExpanded ? (
                    <Typography sx={{ display: "flex" }}>
                      {t("hide")}
                      <KeyboardArrowUpIcon />
                    </Typography>
                  ) : (
                    <Typography sx={{ display: "flex" }}>
                      {t("readCompletely")}
                      <KeyboardArrowDownIcon />
                    </Typography>
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default OurProjects;
